import MuiBottomNavigation from "@mui/material/BottomNavigation";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import React, { useEffect, useRef, useState } from "react";

import { Link, useLocation } from "react-router-dom";
import { Typography } from "../../General";
import styles from "./BottomNavigation.module.scss";

export interface BottomNavigationItem {
    icon: React.ReactNode;
    label: string;
    to: string;
}

export interface BottomNavigationProps {
    items: BottomNavigationItem[];
}

export function BottomNavigation({ items }: BottomNavigationProps) {
    const { pathname } = useLocation();
    const menuRef = useRef<HTMLDivElement>(null);

    const [value, setValue] = useState(pathname);

    useEffect(() => {
        const newValue = `/${pathname.slice(1).split("/")[0]}`;
        setValue(newValue);
    }, [pathname]);

    useEffect(() => {
        const body = document.querySelector("body");

        if (body && menuRef.current) {
            body.style.paddingBottom = `${menuRef.current.offsetHeight / 16}rem`;
        }
    }, []);

    return (
        <MuiBottomNavigation className={styles["nav"]} ref={menuRef} showLabels value={value}>
            {items.map((item) => (
                <MuiBottomNavigationAction
                    className={styles["nav__item"]}
                    component={Link}
                    icon={item.icon}
                    key={item.to}
                    label={
                        <Typography variant={value === item.to ? "menu-label" : "text-xs"}>
                            {item.label}
                        </Typography>
                    }
                    to={item.to}
                    value={item.to}
                />
            ))}
        </MuiBottomNavigation>
    );
}
